/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M23.66,6.28,17.54.16A.6.6,0,0,0,17.1,0H6.68a.6.6,0,0,0-.44.16L.12,6.28a.47.47,0,0,0,0,.63l2.71,3.37a.57.57,0,0,0,.76.13h.06L5.55,9.2l-.1,7.1a2,2,0,0,0,.68,1.49,2.51,2.51,0,0,0,1.67.63H16a2.54,2.54,0,0,0,1.68-.63,2,2,0,0,0,.65-1.49l-.06-7.1,1.9,1.21a.62.62,0,0,0,.79-.06v0L23.69,7a.47.47,0,0,0,0-.67ZM14.81,1.05c-.14,1.26-1.5,3.21-2.89,3.21S9.17,2.36,9,1.05Z"
}), 'CategoryMD');